__turbopack_context__.v({
  "fieldset": "PaymentMethodSelection-module__Rg5MTa__fieldset",
  "headingMargin": "PaymentMethodSelection-module__Rg5MTa__headingMargin",
  "radio": "PaymentMethodSelection-module__Rg5MTa__radio",
});
